<template>
  <div class="page full" id="regist">
    <img class="banner" src="~@/assets/header-img_02.jpg" />
    <div class="form">
      <van-form @submit="onSubmit">
        <van-field
          style="display:none"
          readonly
          clickable
          name="school"
          :value="school_v"
          label="就读学校"
          placeholder="点击选择就读学校"
          @click="showSchool = true"
          :rules="[{ required: true,}]"
        />
        <!-- <p>请选择就读学校</p> -->
        <!-- <van-cell title="就读学校"> -->
        <div class="school flex">
          <div class="title">就读学校</div>
          <van-dropdown-menu :overlay="false">
            <!-- <label>就读学校</label> -->
            <!-- <van-dropdown-item disabled title="就读学校" v-model="value11" :options="option1"></van-dropdown-item> -->

            <van-dropdown-item
              :title="option1_title"
              placeholder="dsss"
              ref="item"
              :disabled="valueable"
            >
              <form action="/">
                <van-search
                  v-model="value2"
                  show-action
                  placeholder="学校搜索"
                  @search="onSearch"
                  @cancel="onCancel"
                  @input="onInput"
                />
              </form>
              <van-cell
                center
                :title="item.text"
                v-for="(item, index) in option1"
                :key="index"
                @click="onConfirm(index)"
                v-show="item.show"
              >
                <template #right-icon>
                  <van-icon name="success" color="#ee0a24" v-if="item.value == value1" />
                </template>
              </van-cell>
            </van-dropdown-item>
          </van-dropdown-menu>
        </div>

        <!-- </van-cell> -->

        <van-field
          readonly
          clickable
          name="grade"
          :value="grade_v"
          label="年级班级"
          placeholder="点击选择就读年级"
          @click="triggerGrade"
          :rules="[{ required: true,}]"
        />
        <van-field
          maxlength="6"
          v-model="stuname"
          name="stuname"
          label="学生姓名"
          placeholder="请输入学生姓名"
          :rules="[{ required: true,}]"
        />
        <van-field
          maxlength="6"
          v-model="parname"
          name="parname"
          label="家长姓名"
          placeholder="请输入家长姓名"
          :rules="[{ required: true,}]"
        />
        <van-field
          :rules="[{ required: true,}]"
          readonly
          clickable
          name="relationship"
          :value="relationship_v"
          label="家庭关系"
          placeholder="点击选择与学生家庭关系"
          @click="showRelationship = true"
        />
        <van-field
          v-model="phone"
          name="phone"
          label="手机号码"
          placeholder="请输入您的手机号码"
          :rules="[{ pattern,message: '请输入正确的电话号码',required: true,}]"
        />
        <div style="margin: 16px;">
          <van-button color="#e2353f" round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>

    <van-popup v-model="showSchool" position="bottom">
      <van-picker
        show-toolbar
        :columns="school"
        @cancel="showSchool = false"
        @confirm="onConfirm_school"
      />
    </van-popup>
    <van-popup v-model="showGrade" position="bottom">
      <van-picker
        show-toolbar
        :columns="grade"
        @cancel="showGrade = false"
        @confirm="onConfirm_grade"
      />
    </van-popup>
    <van-popup v-model="showRelationship" position="bottom">
      <van-picker
        show-toolbar
        :columns="relationship"
        @confirm="onConfirm_relationship"
        @cancel="showRelationship = false"
      />
    </van-popup>
  </div>
</template>

<script>
import index from "./index.js";
export default { ...index };
</script>

<style lang="scss">
@import "./index.scss";
</style>
